/* Page to fetch and display the data and posts for each Profile */
import React, { useEffect, useState } from "react";

import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Card from "react-bootstrap/Card";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { Button, Image } from "react-bootstrap";
import InfiniteScroll from "react-infinite-scroll-component";
import Asset from "../../components/Asset";
import { useCurrentUser } from "../../contexts/CurrentUserContext";
import { axiosInstance, axiosReq } from "../../api/axiosDefaults";
import {
  useProfileData,
  useSetProfileData,
} from "../../contexts/ProfileDataContext";
import { fetchMoreData } from "../../utils/utils";
import NoResults from "../../assets/no-results.png";
import { ProfileEditDropdown } from "../../components/PostDropdown";
import { useRedirect } from "../../hooks/Redirect";
import TopBox from "../../components/TopBox";
import PostTop from "../posts/PostTop";
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config";
import useHostName from "../../hooks/useHostName";

import styles from "../../styles/Profile.module.css";
import appStyles from "../../App.module.css";
import btnStyles from "../../styles/Button.module.css";
// import { useSetNumberContext } from "../../contexts/DeptCategoryContext";

function ProfilePage() {
  useRedirect();
  const host = useHostName();
  const currentUser = useCurrentUser();
  const [hasLoaded, setHasLoaded] = useState(false);
  const [profilePosts, setProfilePosts] = useState({ results: [] });
  // const setNumber = useSetNumberContext();

  const { id } = useParams();
  const history = useHistory();
  const location = useLocation();

  const { setProfileData, handleFollow, handleUnfollow } = useSetProfileData();
  const { pageProfile } = useProfileData();
  const [profile] = pageProfile.results;
  const is_owner = currentUser?.username === profile?.owner;
  const pos = profile?.position;
  const nam = profile?.name;
  const profile_id = profile?.id;
  const [name, setName] = useState("");
  const queryString = window.location.search;
  const [showActionMenu, setShowActionMenu] = useState(true); 

  // Use URLSearchParams to parse the query string
  const params = new URLSearchParams(queryString);
  const epi = params.get("episode");
  // const project = params.get("project");
  // const episodeTitle = params.get("episodeTitle");

  // const handleEdit = () => {
  //   history.push(`/profiles/${id}/edit`);
  // };

  // const handleDelete = async () => {
  //   try {
  //     await axiosRes.delete(`/profiles/${id}/`);
  //     history.goBack();
  //   } catch (err) {
  //   }
  // };

  // useEffect(() => {
  //     if (
  //       currentUser &&
  //       currentUser?.groups.length > 0
  //     ) {
  //       const userRole = currentUser.groups[0].name;
  //       if (userRole === "Admincreative") {
  //         console.log(currentUser?.profile_id === profile_id)
  //         if (Number(profile_id) === Number(currentUser?.profile_id)) {
  //           setShowActionMenu(true);
  //         }
  //       } else if (userRole === "Crew") {
  //         if (Number(profile_id) === Number(currentUser?.profile_id)) {
  //           setShowActionMenu(true);
  //         }
  //       } else if (userRole === "Cast") {
  //         setShowActionMenu(false);
  //       }
  //     }
  //   }, [profile_id, currentUser]);
    useEffect(() => {
    if (!currentUser || !currentUser?.groups?.length) {
      return;
    }

    if (
      currentUser?.groups[0]?.name === "Admincreative" ||
      currentUser?.groups[0]?.name === "Crew"
    ) {
      // Keep menu visibility in sync when navigating between profiles.
      setShowActionMenu(
        Number(profile_id) === Number(currentUser?.profile_id)
      );
      return;
    }

    if (currentUser?.groups[0]?.name === "Cast") {
      setShowActionMenu(false);
      return;
    }

    setShowActionMenu(true);
  }, [profile_id, currentUser]);

  useEffect(() => {
    /* Function to fetch a profile's data and posts
     * and to set the pageProfile in profileData 
       in the ProfileDataContext to the data*/
    setHasLoaded(false);
    const fetchData = async () => {
      try {
        // Retrieve user data from localStorage
        const user = JSON.parse(localStorage.getItem("user"));

        // Extract project_id if available
        const projectId = user?.project_id;

        if (host === CLIENT_PROGRAM_HOSTNAME) {
          const [{ data: pageProfile }, { data: profilePosts }] =
            await Promise.all([
              axiosReq.get(`profiles/${id}/`),
              axiosReq.get(`posts/?owner__profile=${id}`),
            ]);
          setProfileData((prevState) => ({
            ...prevState,
            pageProfile: { results: [pageProfile] },
          }));
          setName(pageProfile.name);
          setProfilePosts(profilePosts);
          setHasLoaded(true);
        } else {
          const [{ data: pageProfile }, { data: profilePosts }] =
            await Promise.all([
              axiosInstance.get(
                `${localStorage.getItem("projectSlug")}/profiles/${id}/`,
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem(
                      "accessToken"
                    )}`,
                  },
                  withCredentials: true,
                }
              ),
              axiosInstance.get(
                `${localStorage.getItem(
                  "projectSlug"
                )}/profile_posts/?owner__profile=${id}${
                  epi ? `&episode_id=${epi}` : ""
                }&project=${projectId}`,
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem(
                      "accessToken"
                    )}`,
                  },
                  withCredentials: true,
                }
              ),
            ]);
          setProfileData((prevState) => ({
            ...prevState,
            pageProfile: { results: [pageProfile] },
          }));
          setName(pageProfile.name);
          setProfilePosts(profilePosts);
          setHasLoaded(true);
          // console.log(pageProfile)
        }
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, [id, setProfileData, location.key, host, epi]);
  
  const topProfile = (
    <Card>
      <Card.Body className={`${styles.Back2} d-none d-lg-block py-0`}>
        <Row className="text-center">
          <Col lg={3} className="text-lg-left d-flex align-items-center ">
            <Image
              className={styles.ProfileImage}
              roundedCircle
              src={profile?.image}
            />
          </Col>
          <Col lg={6}>
            <h2 style={{ textTransform: "capitalize" }}
             className={`${styles.WhiteName} pt-0 mb-0`}>
              {nam}
            </h2>
            <h4 style={{ textTransform: "capitalize" }}
             className={`${styles.Posit} pt-0 mb-0`}>
              {pos}
            </h4>
            <Row className={`${styles.Likes} mx-0 mt-2`}>
              {currentUser &&
                currentUser?.groups.length > 0 &&
                currentUser?.groups[0]?.name !== "Cast" && (
                <>
                {" "}
                <Col xs={4} className="my-0 mx-0 px-0">
                  <p>{profile?.posts_count}</p>
                  <p>Posts</p>
                </Col>
                <Col xs={4} className="my-0 mx-0 px-0">
                  <p>{profile?.followers_count}</p>
                  <p>Followers</p>
                </Col>
                <Col xs={4} className="mx-0 px-0 my-0">
                  <p>{profile?.following_count}</p>
                  <p>Following</p>
                </Col>
              </>
                )}
            </Row>
          </Col>
          <Col lg={3} className={`text-right pt-4 ${styles.Icon}`}>
            {/* {is_owner && <ProfileEditDropdown id={profile?.id} />} */}
            {showActionMenu && (
              <ProfileEditDropdown
                id={profile?.id}
              />
            )}
            {currentUser &&
              !is_owner &&
              (profile?.following_id ? (
                <Button
                  className={`${btnStyles.Button} ${btnStyles.BlackP} mt-4`}
                  onClick={() => handleUnfollow(profile)}
                >
                  Unfollow
                </Button>
              ) : (
                <Button
                  className={`${btnStyles.Button} ${btnStyles.White} mt-4`}
                  onClick={() => handleFollow(profile)}
                >
                  Follow
                </Button>
              ))}
          </Col>
        </Row>
      </Card.Body>
      {/* mobile */}
      <Card.Body className={`${styles.Back2} text-center d-block d-lg-none py-0`}>
        <Row className="px-0">
          <Col xs={2} ></Col>
          <Col xs={8} className="px-0 ">
          <Image
              className={styles.ProfileImage}
              roundedCircle
              src={profile?.image}
            />
          </Col>
          <Col xs={2} className={`${styles.Icon}`} >
          {showActionMenu && (
              <ProfileEditDropdown
              className="float-right"
                id={profile?.id}
              />
            )}
          </Col>
        </Row>
        <Row className="text-center py-2">
          <Col xs={12} >
            <h2 style={{ textTransform: "capitalize" }}
             className={`${styles.WhiteName} pt-0 mb-0`}>
              {nam}
            </h2>
            <h4 style={{ textTransform: "capitalize" }}
             className={`${styles.Posit} pt-0 mb-0`}>
              {pos}
            </h4>
          </Col>
        </Row>
        <Row className={`${styles.Likes} mx-0 `}>
          {currentUser &&
            currentUser?.groups.length > 0 &&
            currentUser?.groups[0]?.name !== "Cast" && (
              <>
                {" "}
                <Col xs={4} className="my-0 mx-0 px-0">
                  <p>{profile?.posts_count}</p>
                  <p>Posts</p>
                </Col>
                <Col xs={4} className="my-0 mx-0 px-0">
                  <p>{profile?.followers_count}</p>
                  <p>Followers</p>
                </Col>
                <Col xs={4} className="mx-0 px-0 my-0">
                  <p>{profile?.following_count}</p>
                  <p>Following</p>
                </Col>
              </>
            )}
        </Row>
        <Row className="py-1">
        <Col xs={12} className="text-center">
          {currentUser &&
            !is_owner &&
            (profile?.following_id ? (
              <Button
                className={`${btnStyles.Button} ${btnStyles.BlackP}`}
                onClick={() => handleUnfollow(profile)}
              >
                Unfollow
              </Button>
            ) : (
              <Button
                className={`${btnStyles.Button} ${btnStyles.White}`}
                onClick={() => handleFollow(profile)}
              >
                Follow
              </Button>
            ))}
        </Col>
        </Row>
      </Card.Body>
    </Card>
  );

  const posts = (
    <>
      <h2 style={{ textTransform: "capitalize" }} className="my-3 text-center">
        {" "}
        Posts
      </h2>
      {profilePosts?.results?.length ? (
        <InfiniteScroll
          children={profilePosts.results.map((post) => (
            <PostTop key={post.id} {...post} setPosts={setProfilePosts} />
          ))}
          dataLength={profilePosts.results.length}
          loader={<Asset spinner />}
          hasMore={!!profilePosts.next}
          next={() => fetchMoreData(profilePosts, setProfilePosts)}
        />
      ) : (
        <Asset
          src={NoResults}
          message={`${profile?.name?.toUpperCase()} hasn't posted yet.`}
        />
      )}
    </>
  );

  return (
    <div>
      <TopBox
        title2={name}
      />
      <Button
        onClick={() => history.goBack()}
        className={`${btnStyles.Button} ${btnStyles.Blue} my-2`}
      >
        Back
      </Button>
      <Row className="mx-0 my-2">
        <Col className="pb-2 px-0">
          <div className={appStyles.Content}>
            {hasLoaded ? (
              <>
                {topProfile}
                {currentUser &&
                  currentUser?.groups.length > 0 &&
                  currentUser?.groups[0]?.name !== "Cast" &&
                  posts}
              </>
            ) : (
              <Asset spinner />
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default ProfilePage;
